import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignItems", "children", "flexDirection"];
import { LayoutFlex } from './LayoutFlex';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayoutHorizontal = _ref => {
  let {
      alignItems = 'center',
      children,
      flexDirection = 'row'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutFlex, Object.assign({}, rest, {
    alignItems: alignItems,
    flexDirection: flexDirection,
    children: children
  }));
};